// extracted by css-extract-rspack-plugin
export default {"icon":"x5sv547YGwKeVite","trigger":"Oc9xhoYc003Wbt5M"};